<template>
  <div id="assistant-hint" :class="{ displayed: hint != null }">
    <div class="content-wrapper f-h f-w" ref="contentWrapper">
      <div class="content f-h f-w">
        <close-button @click.native="hide" :white="true"></close-button>
        <div class="hint-img">
          <img class="f-w" src="/images/ia/sensei-full.png" alt="" />
        </div
        ><div class="hint-text">
          <div v-html="hintText"></div>
          <div class="option-link" v-for="link in hintLinks" @click="link.action">
            <span>{{ link.link }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Intelligent assistant hints
 */
import CloseButton from '@/components/close-button.vue';
import IAHintProvider from '@/utils/classes/IAHintProvider';
import IATeacher from '@/utils/classes/IATeacher';
import { globalEventDispatcher, ShizenGlobalEvent } from '@/utils/event-dispatcher/global';

export default {

  name: 'AssistantHint',

  components: {
    CloseButton,
  },

  data() {
    return {
      hint: null,
      hintText: '',
      hintLinks: [],
      previousHints: [],
      displayTimeout: null,
    };
  },

  computed: {
    disabled() {
      return this.App.user.hideHints == '1';
    },
  },

  beforeDestroy() {
    clearTimeout(this.displayTimeout);
  },

  mounted() {
    globalEventDispatcher.register(`${ShizenGlobalEvent.SET_LANGUAGE}`, this.hide);
  },

  methods: {
    hide() {
      this.hint = null;
    },
    /**
     * Show a hint above everything
     * @param  {Object} component The component displayed in the router view
     * @param  {Number} chance    Integer between 1 & 100 to determine the probability to show the hint
     * @param  {Number} delay     The delay after which show the hint
     * @param  {String} category  If different from component name
     * @return {Boolean}          True if a hint was displayed, false otherwise
     */
    showHint(component, chance, delay, category) {
      if (this.disabled || (!category && !component)) {
        return;
      }
      // Default variables
      if (chance < 1) {
        chance = 1;
      } else if (chance > 100) {
        chance = 100;
      }
      chance = Number(chance);
      chance = chance < 1 || chance > 100 ? 1 : chance;
      delay = Number(delay);
      delay = delay < 0 ? 0 : delay;
      category = category || component.$options.name;
      // Category may be an array of categories
      var potentialHints = [];
      if (Array.isArray(category)) {
        for (var i = 0, j, jlen, cat, hint ; i < category.length ; i++) {
          cat = IAHintProvider.categories[category[i]] || [];
          for (j = 0, jlen = cat.length ; j < jlen ; j++) {
            hint = cat[j];
            hint.category = category[i];
            potentialHints.push(hint);
          }
        }
      } else {
        potentialHints = IAHintProvider.categories[category];
        for (var i = 0, hint ; i < potentialHints.length ; i++) {
          potentialHints[i].category = category;
        }
      }
      // Probability to show the hint
      var j;
      if (potentialHints && 0 == getRandomInt(100 / chance)) {
        this.hintText = '';
        this.hintLinks = [];
        var hintChance, totalChances = 0, chancesIndexes = {}, msgToShow = null;
        // Find which msg to show according to weight
        for (var i = 0, len = potentialHints.length ; i < len ; i++) {
          hintChance = potentialHints[i].chance || 1;
          // If hint has been displayed earlier, chance is divided by 2
          for (j = 0 ; j < this.previousHints.length ; j++) {
            if (this.previousHints[j] == potentialHints[i].category + potentialHints[i].id) {
              hintChance /= 2;
            }
          }
          chancesIndexes[i] = totalChances;
          totalChances += hintChance;
        }
        var res = getRandomFloat(totalChances), idx;
        for (var index in chancesIndexes) {
          idx = Number(index);
          if (res >= chancesIndexes[idx] && res < (chancesIndexes[idx + 1] || totalChances)) {
            this.previousHints.push(potentialHints[idx].category + potentialHints[idx].id);
            if (this.previousHints.length > 20) {
              this.previousHints.shift();
            }
            this.displayTimeout = setTimeout(() => {
              this.displayHint(potentialHints[idx]);
            }, delay);
            return true;
          }
        }
      }
      // No hints displayed
      return false;
    },
    displayHint(hint) {
      this.hint = hint;
      this.hintText = this.$t('hints.' + hint.text);
      var links = [];
      if (hint.senseiOption) {
        var trKey = 'sensei.' + hint.senseiOption, trTitleKey = 'sensei.' + hint.senseiOption + '_TITLE';
        var tr = this.$t(trKey), trTitle = this.$t(trTitleKey);
        if (tr != trKey && trTitle != trTitleKey) {
          // Option exists
          links = [
            {
              link: trTitle,
              action: () => {
                IATeacher.lesson(hint.senseiOption);
              },
            },
          ];
        }
      } else if (hint.links) {
        for (var i = 0 ; i < hint.links.length ; i++) {
          const page = hint.links[i].page;
          links.push({
            link: this.$t(hint.links[i].text),
            action: () => {
              this.$router.push(page);
            }
          })
        }
      } else {
        // Default links
        if (links.length == 0) {
          links = [
            {
              link: this.$t('hints.SHOW_IA'),
              action: this.App.showIA
            }
          ];
        }
      }
      this.hintLinks = links;
    },
  },
};
</script>
